import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { JeevesModalService } from 'gung-standard-jeeves';
import { Customer, CustomerContact, GungModalService } from 'gung-standard';
import { ColmecAddCustomerModalComponent } from '../components/colmec-add-customer-modal/colmec-add-customer-modal.component';
import { ColmecAddContactModalComponent } from '../components/colmec-add-contact-modal/colmec-add-contact-modal.component';
import { ColmecEditContactModalComponent } from '../components/colmec-edit-contact-modal/colmec-edit-contact-modal.component';

@Injectable({
  providedIn: 'root'
})
export class ColmecJeevesModalService extends JeevesModalService {
  constructor(protected modalService: NgbModal, protected gungModalService: GungModalService) {
    super(modalService);
  }

  openAddContactModal(contact: Customer) {
    this.modalRef = this.modalService.open(ColmecAddContactModalComponent, this.modalOptions);
    this.modalRef.componentInstance.contact = contact;
    this.modalRef.result.then(
      result => {},
      reason => {}
    );
  }

  openEditContactModal(customerContact: CustomerContact) {
    this.modalRef = this.modalService.open(ColmecEditContactModalComponent, this.modalOptions);
    this.modalRef.componentInstance.customerContact = customerContact;
    this.modalRef.result.then(
      result => {},
      reason => {}
    );
  }

  // openAddCustomerModal() {
  //   this.modalRef = this.modalService.open(RefJeevesAddCustomerModalComponent, this.modalOptions);
  //   this.modalRef.result.then((result) => {
  //     if (result) {
  //       const modalRef = this.modalService.open(RefMessageModalComponent);
  //       modalRef.componentInstance.message = 'CUSTOMER_CREATE_SUCCESS';
  //     }
  //   }, (reason) => { });
  // }

  openEditCustomerModal(customer: Customer) {
    this.modalRef = this.modalService.open(ColmecAddCustomerModalComponent, this.modalOptions);
    this.modalRef.componentInstance.create = false;
    this.modalRef.componentInstance.customer = customer;
    this.modalRef.result.then(
      result => {
        if (result) {
          this.gungModalService
            .openConfirmYesNoModal(undefined, 'CUSTOMER_UPDATE_SUCCESS', { size: 'sm' }, 'OK', null)
            .then(_ => {});
        }
      },
      reason => {}
    );
  }
}
